import { Modal } from "@smart/itops-sb-design-system-dom";

export type AutofillUnavailableModalProps = {
  open: boolean;
  onClose: () => void;
};

export const AutofillUnavailableModal = ({
  open,
  onClose,
}: AutofillUnavailableModalProps) => (
  <Modal
    open={open}
    onClose={onClose}
    header={{
      text: "Autofill Assistant is unavailable",
      icon: "regularCircleInfo",
    }}
    footer={{
      buttons: [
        {
          text: "Ok",
          variant: "primaryDefault",
          onClick: onClose,
        },
      ],
    }}
  >
    <p>
      The Autofill Assistant has already been used and is therefore no longer
      available for this form.
    </p>
  </Modal>
);
